module.exports = __webpack_public_path__ + "logo_full-96e7a97fe469f75a23a74852b2478fa3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/logo_full.svg
// module id = 268
// module chunks = 76